/** Entry point: wire the browser's fetch, EventSource and clocks into the shell. */
import "./styles/main.css";
import { bootShell } from "./app/shell.ts";
import { realMono } from "./app/time.ts";

const root = document.getElementById("app");
if (root !== null) {
  bootShell(root, {
    win: window,
    fetch: (input, init) => window.fetch(input, init),
    createSource: (url) => new EventSource(url, { withCredentials: true }),
    mono: realMono,
    navigate: (url) => {
      window.location.assign(url);
    },
    schedule: (task, ms) => {
      const id = window.setTimeout(task, ms);
      return () => {
        window.clearTimeout(id);
      };
    },
  });
}
